module.exports = __webpack_public_path__ + "static/media/band-aid.079c1829.svg";